export function setupImageLoad() {
    const imageLoadELements = document.querySelectorAll('[data-action*="image-load"]');

    function imageLoaded(e) {
        const elementImage = e.target ? e.target : e;
        const element = elementImage.closest('[data-action*="image-load"]');

        if (element) {
            element.classList.add('image-loaded');
        }
    }

    imageLoadELements.forEach(element => {
        const elementImage = element.querySelector('img');

        if (elementImage) {
            if (elementImage.complete) {
                imageLoaded(elementImage);
            } else {
                elementImage.addEventListener('load',imageLoaded);
                elementImage.addEventListener('error',imageLoaded);
            }
        }
    });
}